// extracted by mini-css-extract-plugin
export default {"root":"_r4jjRJZFsaJL2mpdJA6","placeHolderShimmer":"EhpcFS8mp6xyj5bfBQNS"};